import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { PresidioMockQuoteEffects } from '../store/presidio-mock-quote.effects';

/** DEMO-ONLY exports — omit this module when wiring live ICM. */
@NgModule({
  imports: [EffectsModule.forFeature([PresidioMockQuoteEffects])],
})
export class PresidioDemoExportsModule {}
